import React from 'react';
import Poll from '@components/Poll/Poll';
import { useReferencedComponent } from '@hooks/useReferencedComponent';
import { useAuth0Token } from '@hooks/useAuth0Token';
import { SanityPollData } from './Poll.types';

export const PollBlock = ({ documentId }: { documentId: string }) => {
  const { loading } = useAuth0Token();
  const data = useReferencedComponent(documentId) as SanityPollData | null;

  if (loading || !data || data.ended) return null;

  const firstQuestion = data.questions?.[0];
  const options =
    firstQuestion?.answers?.map((answer) => ({
      id: answer.key,
      text: answer.answer,
      votes: answer.statistics?.numberOfAnswers || 0,
    })) || [];

  return (
    <Poll
      pollId={documentId}
      questionKey={firstQuestion.key}
      title={firstQuestion.question || data.title}
      disclaimer={data.disclaimer}
      options={options}
      image={data.image}
      video={data.video}
      style={data.style || 'light'}
      userAccessibility={data.userAccessibility}
    />
  );
};
